define(['jquery'], function($) {
    // 'use strict';

    let stupidFace = function() {
        console.log("Your face is stupid!");
    };

    return {
        init: function() {
            console.log("sent_messages => init() => START");
            $('.qm_sent_msgs').on('click', '.qm_sm_trash', function (ev) {
                ev.preventDefault();
                console.log("Trash this message yo");
                console.log("What is the id: " + $(this).data("msgid"));
                stupidFace();
            });

            // $('.qm_sm_trash').click(function(ev) {
            //     ev.preventDefault();
            //     console.log("Trash this message yo");
            //     console.log("What is the id: " + $(this).data("msgid"));
            // });
        }
    };
});
